import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';
import { getCurrentLanguage, setLanguage } from '../i18n/translations';

const LanguageSwitcher = ({ className = "" }) => {
  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'gu' : 'en';
    setLanguage(newLang);
    setCurrentLang(newLang);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={`flex items-center gap-1 text-gray-600 hover:text-pink-600 ${className}`}
      title={currentLang === 'en' ? 'Switch to Gujarati' : 'Switch to English'}
    >
      <Globe className="w-4 h-4" />
      <span className="text-xs font-medium">
        {currentLang === 'en' ? 'ગુ' : 'EN'}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;